export const palyersData = [{
        id: 1,
        name: "Harry Kane",
        position: " Striker ",
        image: "/Images/Harry-Kane2-gallery.jpg",
        type: "Goals",
        value: 55
    },

    {
        id: 2,
        name: "Michael Olise",
        position: " Right Winger ",
        image: "/Images/Olise-gallery.jpg",
        type: "Goals",
        value: 21
    },

    {
        id: 3,
        name: "Luis Díaz",
        position: " Left Winger ",
        image: "/Images/Luis-Diaz-gallery.jpeg",
        type: "Goals",
        value: 25
    },

    {
        id: 4,
        name: "Jamal Musiala",
        position: " Central Attacking Midfielder ",
        image: "/Images/Musiala-gallery.jpg",
        type: "Goals",
        value: 7
    },

    {
        id: 5,
        name: "Manuel Neuer",
        position: " Goal Keeper ",
        image: "/Images/manuMadrid.png",
        type: "Clean Sheets",
        value: 11
    },

    {
        id: 6,
        name: "Joshua Kimmich",
        position: " Defensive Midfielder ",
        image: "/Images/Kimmich3.jpg",
        type: "Goals",
        value: 2
    },

]

export const legendsData = [{
        id: 1,
        name: "Franck Ripéry",
        image: "/Images/ripery-legend.jpg",
        years: " 2007 - 2019 ",
        type: "Goals",
        value: 124
    },

    {
        id: 2,
        name: "Arjen Robben",
        image: "/Images/robben-gallery2.jpg",
        years: " 2009 - 2019 ",
        type: "Goals",
        value: 144
    },

    {
        id: 3,
        name: "Oliver Kahn",
        image: "/Images/Kahn-gallery.jpg",
        years: " 1994 - 2008 ",
        type: "Clean Sheets",
        value: 247
    },

    {
        id: 4,
        name: "Thomas Müller",
        image: "/Images/Muller-gallery.jpg",
        years: " 2000 - 2025 ",
        type: "Goals",
        value: 250
    },

    {
        id: 5,
        name: "Franz Beckenbauer",
        image: "/Images/Franz-gallery.png",
        years: " 1964 - 1977 ",
        type: "Goals",
        value: 44
    },

    {
        id: 6,
        name: "Karl-Heinz-Rummenigge",
        image: "/Images/Karl-gallery.jpg",
        years: " 1974 - 1984 ",
        type: "Goals",
        value: 162
    },

    {
        id: 7,
        name: "Bastian Schweinsteiger",
        image: "/Images/Bastian-gallery.jpg",
        years: " 2002 - 2015 ",
        type: "Goals",
        value: 68
    },

    {
        id: 8,
        name: "Philipp Lahm",
        image: "/Images/lahm-gallery.jpg",
        years: " 2002 - 2017 ",
        type: "Goals",
        value: 16
    },

    {
        id: 9,
        name: "Robert Lewandowski",
        image: "/Images/Liwa2.jpg",
        years: " 2014 - 2022 ",
        type: "Goals",
        value: 344
    },
]

export const momentsData = [{
        id: 1,
        image: "/Images/moments-gallery.jpg",
        desc: "The Family",
        year: "2025"
    },

    {
        id: 2,
        image: "/Images/moments-gallery2.png",
        desc: "VS_ST.Pauli",
        year: "2026"
    },


    {
        id: 3,
        image: "/Images/moments-gallery3.png",
        desc: "Atleti Azzurri",
        year: "2026"
    },

    {
        id: 4,
        image: "/Images/moments-gallery4.jpg",
        desc: "Trophy Celebration",
        year: "2026"
    },

    {
        id: 5,
        image: "/Images/moments-gallery5.png",
        desc: "VS_Real Madrid",
        year: "2026"
    },

    {
        id: 6,
        image: "/Images/moments-gallery6.png",
        desc: "VS_Freiburg",
        year: "2026"
    },

    {
        id: 7,
        image: "/Images/moments-gallery7.png",
        desc: "The Best",
        year: "2026"
    },

    {
        id: 8,
        image: "/Images/moments-gallery8.jpg",
        desc: "waiting Victory",
        year: "2024"
    },

    {
        id: 9,
        image: "/Images/pauli-game.png",
        desc: "The Red Hell",
        year: "2026"
    },

]